import React, { FC } from "react";
import { Locale } from "../../../locales/Locale";
import { cityConfig } from "../../../enums/City";

interface IRenderCity {
    value?: string;
}

export const RenderCity: FC<IRenderCity> = ({ value = "" }) => {
    const normalized = value.trim().toLowerCase();
    const match = cityConfig.find(city => city.name.toLowerCase() === normalized);

    if (match?.locaId) {
        return <Locale localeId={match.locaId} />;
    }

    return value ? <>{value}</> : <>N/A</>;
};
